import { EditDescriptor } from "@progress/kendo-react-data-tools";
import {
  GridColumnProps,
  Grid,
  GridItemChangeEvent,
  GridColumn,
} from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import styles from './DataTable.module.scss';
import styled from 'styled-components';
interface Props {
  dataItemKey: string;
  columns: GridColumnProps[];
  data: any[];
  onItemChange: (e: GridItemChangeEvent) => void;
  edit: EditDescriptor;
}

const StyledGrid = styled(Grid)`
  .k-column-title {
    min-width: 0;
    font-weight: 600;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex-shrink: 1;
    overflow: hidden;
    font-weight: bold; /* Make the font bold */
  }
`;

export const EditableGrid = ({
  dataItemKey,
  columns,
  data,
  onItemChange,
  edit,
}: Props) => {
  return (
    <StyledGrid
      data={data}
      dataItemKey={dataItemKey}
      editable={true}
      edit={edit}
      scrollable="scrollable"
      onItemChange={onItemChange}
    >
      {columns.map((columnProps) => (
        <GridColumn 
        className={styles.headerColumn}
        key={columnProps.title} {...columnProps}
        title={columnProps.title}
        />
      ))}
    </StyledGrid>
  );
};
